import VerificationCodeFields from './connected';

export default VerificationCodeFields;